// removed by extract-text-webpack-plugin
module.exports = {"TemplateSelector":"TemplateSelector___1uJ1c","btn":"btn___3b8-A","backer":"backer___2VrUM","frame":"frame___qus3D","header":"header___1okse","h3":"h3___3PReW","close":"close___-WKI8","apply":"apply___1vOxs","content":"content___3XHMm","li":"li___1fdE_","desc":"desc___qV7HZ","currentTab":"currentTab___3aJm0","templateSelect":"templateSelect___1GZDE","select":"select___2Qls2","dropdown":"dropdown___hmJbH","option":"option___uA_JG","check":"check___1MVUT","label":"label___3csCn"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/TemplateSelector/styles.scss
// module id = 337
// module chunks = 0